module.exports = __webpack_public_path__ + "img/airplane-travel.9620168d.jpg";